import * as messageService from "../../services/message.service";
import * as dealerManagerService from '../../services/dealerManager.service';


const state = {
    dealerManagerAll:[],
    dealerManagerAllActive:[],
    dealerManagerDropdown:[],
};

const getters = {
    gettDealerManagerAll:state => (state.dealerAll),
    gettDealerManagerAllActive:state => (state.dealerAllActive),
    gettDealerManagerDropdown:state => (state.dealerManagerDropdown),
};

const actions = {
    async fetchDealerManagerAll({ commit } ){
        try {
            const response = await dealerManagerService.all();
            commit('setDealerManagerAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchDealerManagerAllActive({ commit } ){
        try {
            const response = await dealerManagerService.allActive();
            commit('setDealerManagerAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchDealerManagerDropdown({ commit } ){
        try {
            const response = await dealerManagerService.dropdown();
            commit('setDealerManagerDropdown', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setDealerManagerAll:(state, res) => (
        state.dealerManagerAll =  res
    ),
    setDealerManagerAllActive:(state, res) => (
        state.dealerManagerAllActive =  res
    ),
    setDealerManagerDropdown:(state, res) => (
        state.dealerManagerDropdown =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}